import React, { Component } from 'react';
import InputText from '../../../../common/components/input-text/input-text';
import Select from 'react-select';
import Button from '../../../button-classic/button-classic';
import '../../../route_code/route_code.less';
import Cx from "classnames";
import { setItemToSessionStorage } from '../../../../utils/sessionStorage';
import { COROMANDEL_COMPANY_IDS } from '../../../../utils/common';

class AddInventory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {
                zone: this.props.editData ? this.props.editData.zone : '',
                total_area_in_sqft: this.props.editData ? this.props.editData.total_area_in_sqft : '',
                carpet_area_in_sqft: this.props.editData ? this.props.editData.carpet_area_in_sqft : '',
                storage_capacity_in_mt: this.props.editData ? this.props.editData.storage_capacity_in_mt : '',
                material_number: this.props.editData ? this.props.editData.material_number : '',
                storage_location: this.props.editData ? this.props.editData.storage_location : '',
                batch_number: this.props.editData ? this.props.editData.batch_number : '',
                company_id: this.props.editData ? this.props.editData.company_id : this.props.companyId,
                branch_name: this.props.editData ? this.props.editData.branch_name : '',
                branch_code: this.props.editData ? this.props.editData.branch_code : '',
                branch_id: this.props.editData ? this.props.editData.branch_id : '', fiscal_current_year: this.props.editData ? this.props.editData.fiscal_current_year : '',
                current_period: this.props.editData ? this.props.editData.current_period : '',
                used_stock: this.props.editData ? this.props.editData.used_stock : '',
                inventory_id: this.props.editData ? this.props.editData.inventory_id : undefined,
            }
        }
    }

    componentDidMount() {
        setItemToSessionStorage('InventoryIn', this.props.editData)
    }

    onChangeHandler = (value, id) => {
        let { data } = this.state;
        if (id === 'fiscal_current_year') {
            data[id] = value.replace(/\D/g, '').slice(0, 4); s
        }
        if (id === 'total_area_in_sqft' || id === 'carpet_area_in_sqft' || id === 'storage_capacity_in_mt') {
            data[id] = value.replace(/[^0-9.]/g, '');
        } else {
            data[id] = value;
        }
        this.setState({ data });
    }

    onSave = () => this.props.onSave(this.state.data)

    onUpdate = () => this.props.onUpdate(this.state.data)

    render() {

        const { data } = this.state;
        const { companyId, fetchDepotName, plantsList } = this.props;
        const isCoroMandel = COROMANDEL_COMPANY_IDS.includes(companyId);

        const branchOptions = isCoroMandel
            ? (plantsList || []).map(d => ({
                label: d.plant_name || d.branch_name,
                value: d.plant_id || d.branch_id,
                code: d.plant_code || d.branch_code
            }))
            : (fetchDepotName || []).map(d => ({
                label: d.branch_name,
                value: d.branch_id,
                code: d.branch_code
            }));

        const disable = isCoroMandel
            ? !(data.branch_id && data.material_number && data.storage_location && data.batch_number)
            : !(data.branch_id && data.storage_capacity_in_mt);

        return (
            <div className="route_code_detail">
                <div onClick={this.props.toggleAdd} className="overlay"></div>

                <div id="modal" className="modal-popup">
                    <div className="pop-heading">
                        {`${this.props.editData ? 'Edit' : 'Add'} Inventory Master`}
                    </div>

                    <div className="route-detail">
                        <div className="details-section">


                            <div className="select-wrap-depot">
                                <div className="label">{isCoroMandel ? 'Branch' : 'Depo Details'}<span className="error-color">*</span></div>

                                <Select
                                    options={branchOptions}
                                    className={Cx("selectpack")}
                                    value={branchOptions.find(el => el.value === data.branch_id) || null}
                                    getOptionLabel={opt => opt.label + '-' + opt.code}
                                    onChange={(opt) => {
                                        let { data } = this.state;
                                        data.branch_name = opt.label;
                                        data.branch_id = opt.value;
                                        data.branch_code = opt.code;
                                        this.setState({ data });
                                    }}
                                />
                            </div>


                            {isCoroMandel &&
                                <InputText
                                    placeholder="Branch Code"
                                    id="branch_code"
                                    label="Branch Code"
                                    value={data.branch_code}
                                    disabled
                                />
                            }


                            {isCoroMandel && <>
                                <InputText
                                    placeholder="Material Number"
                                    id="material_number"
                                    label="Material Number"
                                    changeHandler={this.onChangeHandler}
                                    value={data.material_number}
                                    required
                                />

                                <InputText
                                    placeholder="Storage Location"
                                    id="storage_location"
                                    label="Storage Location"
                                    changeHandler={this.onChangeHandler}
                                    value={data.storage_location}
                                    required
                                />

                                <InputText
                                    placeholder="Batch Number"
                                    id="batch_number"
                                    label="Batch Number"
                                    changeHandler={this.onChangeHandler}
                                    value={data.batch_number}
                                    required
                                />
                            </>}
                            <InputText
                                placeholder="Fiscal Current Year"
                                id="fiscal_current_year"
                                label="Fiscal Current Year"
                                changeHandler={this.onChangeHandler}
                                value={data.fiscal_current_year}
                                maxLength={4}
                                type="number"
                                required
                            />

                            <InputText
                                placeholder="Current Period"
                                id="current_period"
                                label="Current Period"
                                changeHandler={this.onChangeHandler}
                                value={data.current_period}
                                required
                            />

                            <InputText
                                placeholder="Used Stock"
                                id="used_stock"
                                label="Used Stock"
                                changeHandler={this.onChangeHandler}
                                value={data.used_stock}
                                required
                            />


                            {!isCoroMandel && <>
                                <InputText
                                    placeholder="Storage Capacity"
                                    id="storage_capacity_in_mt"
                                    label="Storage Capacity (in mt)"
                                    changeHandler={this.onChangeHandler}
                                    value={data.storage_capacity_in_mt}
                                    required
                                />

                                <InputText
                                    placeholder="Total Area"
                                    id="total_area_in_sqft"
                                    label="Total Area (sqrt)"
                                    changeHandler={this.onChangeHandler}
                                    value={data.total_area_in_sqft}
                                />

                                <InputText
                                    placeholder="Carpet Area"
                                    id="carpet_area_in_sqft"
                                    label="Carpet Area (sqrt)"
                                    changeHandler={this.onChangeHandler}
                                    value={data.carpet_area_in_sqft}
                                />
                            </>}

                        </div>

                        <div className="button_route">
                            <Button value="Cancel" click={this.props.toggleAdd} />
                            {!this.props.editData
                                ? <Button value="Save" click={this.onSave} disabled={disable} />
                                : <Button value="Update" click={this.onUpdate} disabled={disable} />
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default AddInventory;
